/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/*****************
 ** WEBPACK FOOTER
 ** /Users/gaearon/p/react-devtools/~/react-dom/lib/ReactPropTypesSecret.js
 ** module id = 118
 ** module chunks = 0
 **/